// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JqZ9","textarea":"styles_textarea__12k-0"};